import React from 'react';
import { connect } from 'react-redux';
import { updatePhaseTask, clearValidationErrors } from 'actionCreators';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import PropTypes from 'prop-types';
import PhaseTask from './phase_task';
import BeforePhotosTaskModal from 'BeforeAndAfterModal';

export class BeforePhotos extends PhaseTask {
  isDisabled = () => false

  onClick = () => {
    if (this.props.task.status === 'complete') this.toggleStatus();
    else this.setState({ modalActive: true });
  }

  renderChildren = () => {
    const { phase, task } = this.props;
    return (<BeforePhotosTaskModal
      phase={phase}
      leadCertNumber={123456}
      task={task}
      active={this.state.modalActive}
      completeTask={this.completeTask}
      onClose={this.handleClose}
    />);
  }
}

BeforePhotos.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

export const before_photos = connect(() => ({}),
{ updatePhaseTask, clearValidationErrors })(BeforePhotos);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/before_photos.jsx